import styled from "styled-components";
import { ExternalLink } from "lucide-react";

import Panel from "../Panel";
import { Button, PageStack } from "../ui";

const ADP_PAYOUT_SETUP_URL =
  "https://www.workmarket.com/recruiting-campaign/D5DAD8B369D9C090880344DBFE9B8161AB4C9C7649ECBB98D79896B5A154E115";

const Body = styled.p`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #4a423b;
  margin: 0 0 16px;
`;

const PaymentsPage = () => (
  <PageStack>
    <Panel title="Payout Setup">
      <Body>
        JackedRabbit pays partners through ADP. To receive your payouts, your studio needs a payout
        account set up in ADP. If you've already completed this, there's nothing more to do.
      </Body>
      <Button
        $variant="primary"
        onClick={() => window.open(ADP_PAYOUT_SETUP_URL, "_blank", "noopener,noreferrer")}
      >
        Set up payouts in ADP
        <ExternalLink size={15} />
      </Button>
    </Panel>
  </PageStack>
);

export default PaymentsPage;
